import React from 'react';
import UserAvatar from '../../components/UserAvatar';
import DataModel from '../../models/DataModel';

import EmailIcon from '../../assets/images/email-icon-gray.svg';
import MessageIcon from '../../assets/images/message-icon-gray.svg';
import SpeakerIcon from '../../assets/images/speaker.svg';

import './MobileUserProfile.scss';

export default class MobileUserProfile extends React.Component {

  openContactUrl(contactUrl) {
    if (contactUrl) {
      if (window.cordova) {
        // mobile
        window.open(contactUrl, '_system');
      }
      else window.location = contactUrl;
    }
  }

  render() {
    const { user, hasLogoutButton } = this.props;
    // let islogged=DataModel.badConnectionStatus;

    if (!user) return null;
    else return (
      <div className='user-profile'>
          <UserAvatar user={user} largest={true}/>
          <h2 className='user-profile__name'>{user.first_name + ' ' + user.last_name}</h2>
          <span className='user-profile__divider'/>
          <div className='user-profile__contact-info'>
            <span className='email' onClick={() => this.openContactUrl('mailto:'+user.email)}>
              <img src={EmailIcon} alt='email'/>
              <p>{user.email}</p> 
            </span>
            <span className='sms' onClick={() => this.openContactUrl('sms://'+user.phone)}>
              <img src={MessageIcon} alt='message'/>
              <p>{user.phone || 'No Phone #'}</p> 
            </span>
            <span className='phone' onClick={() => this.openContactUrl('tel:'+user.phone)}>
              <img src={SpeakerIcon} alt='phone'/>
              <p>{user.phone || 'No Phone #'}</p>
            </span>
          </div>
          {/* { hasLogoutButton &&  islogged==true &&
            <button className="user-profile__logout" onClick={DataModel.mobileBridge.mobileLogout}>LOG OUT</button>
          }
           { hasLogoutButton && islogged==false && 
            <button className="user-profile__logout-badconnection">LOG OUT</button>
          }  */}
          { hasLogoutButton && 
            <button className="user-profile__logout" onClick={DataModel.mobileBridge.mobileLogout}>LOG OUT</button>
          }
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/MobileUserProfile/index.js